import { PlaneGeometry } from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";

const defaultOptions = {
  text: "这是一段示例文字",
  textSize: 0.03,
  textColor: 0x000000,
  font: "normal",
  color: undefined,
  align: "center",
  outlineWidth: 0.001,
  outlineColor: 0xffffff,
  lineTextCount: 20,
};

/*
  使用案例

    // 创建绿底黑字的文字并添加到场景中
       let text = this.uiLib.createText({
        text: "创建绿底黑字的文字，超过10个字符会自动换行",
        lineTextCount: 10,
        textColor: 0xffffff,
        color: 0x00ff00,
        textSize: 0.05,
      });
      this.uiLib.addUIToScene(text);

      let text1 = this.uiLib.createText({
        text: "这是无底黑字",
        textColor: 0xffffff,
        textSize: 0.1,
      });
      this.uiLib.addUIToScene(text1);
      text1.position.y = 0.3;

 */

export class VText extends VBase {
  /**
   * options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为100000
   *      text: 按钮文字内容，默认为"按钮"
   *      textSize: 文字大小，默认为 0.03
   *      textColor: 文字颜色，默认为 0x000000
   *      font: 字体正常或粗体，"normal"-正常  "bold"-粗体 ，默认为"normal"
   *      color: 文字背景填充色，默认为null
   *      outlineWidth: 文字描边宽度，默认为 0.001
   *      outlineColor: 文字描边颜色，默认为 0xffffff
   *      lineTextCount: 单行最多多少个字符，默认为20
   *      align: 文字对齐方式，"left"-左对齐  "center"-居中对齐  "right"-右对齐，默认为"center"
   *      createdCB: 由于创建文字对象有延迟，可以使用这个回调在创建文字完成后执行，参数为创建的Text，不是VText。默认为null
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 100000,
      priority: options.priority !== undefined ? options.priority : 1,
      width: 0.001,
      height: 0.001,
      text: options.text !== undefined ? options.text : defaultOptions.text,
      textSize:
        options.textSize !== undefined
          ? options.textSize
          : defaultOptions.textSize,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
      font: options.font ? options.font : defaultOptions.font,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      align: options.align ? options.align : defaultOptions.align,
      outlineColor:
        options.outlineColor !== undefined
          ? options.outlineColor
          : defaultOptions.outlineColor,
      outlineWidth:
        options.outlineWidth !== undefined
          ? options.outlineWidth
          : defaultOptions.outlineWidth,
      lineTextCount: options.lineTextCount
        ? options.lineTextCount
        : defaultOptions.lineTextCount,
      createdCB: options.createdCB ? options.createdCB : null,
    };

    super(tempOptions, vuiLib);
    this._vType = "VText";

    if (!tempOptions.color) {
      this.material.opacity = 0.01;
      this.material.depthWrite = false;
    }

    this._otherProps = {
      lineTextCount: tempOptions.lineTextCount,
      createdCB: tempOptions.createdCB,
    };

    this.name = "VText";
    this.text = tempOptions.text;

    // 拆分成多行
    if (this._textProps.text.length > this._otherProps.lineTextCount) {
      var resText = this._splitString(
        this._textProps.text,
        this._otherProps.lineTextCount
      );
      this._textProps.text = resText.join("\n");
    }

    // 文字
    const text = VUtil.createText(
      this._textProps.text,
      this._textProps.textSize,
      this._textProps.textColor,
      this._textProps.font,
      (t) => {
        // 某些情况下，文字对象可能还没创建好，此时this.object被删除了（主动删除的），所以要判断一下
        if (!this.geometry || !this._otherProps) return;
        this.geometry = new PlaneGeometry(t._width, t._height);

        this.add(text);

        this.width = t._width;
        this.height = t._height;

        if (this._otherProps.createdCB) {
          this._otherProps.createdCB(text);
        }
      },
      this._textProps.outlineWidth,
      this._textProps.outlineColor,
      this._textProps.align
    );
    text.position.z = 0.001;
    text.renderOrder = this._baseProps.renderOrder;
  }

  /**
   * 将字符串按字数限制拆分成数组
   * @param {*} str
   * @param {*} lineLimit 每行最多的字数限制
   */
  _splitString(str, lineLimit) {
    var strs = [];
    while (str.length > lineLimit) {
      strs.push(str.substring(0, lineLimit));
      str = str.substring(lineLimit);
    }
    strs.push(str);
    return strs;
  }

  // 此对象不需要点击交互
  getClickable() {
    return [];
  }
}
